<template>
  <div class="flex-1 d-flex justify-content-center align-items-center text-center " style="line-height: 2em">
    <div class=" fs-2">
      <div style="height:250px;width:100%;">
        <Logo :zoom="-.5"></Logo>
      </div>
      <div class="fw-bolder fs-2">
        HELLO
        <template v-if="user">
          {{ user.name }} {{ user.prename }}
        </template>
      </div>
      <div class="fw-bolder badge badge-light-primary badge-lg">
        {{ user.email }}
      </div>
      <div v-if="currentTenant">
        Vous êtes connecté à
        <div class="fw-bolder text-primary">{{ currentTenant?.label }}</div>
      </div>
      <div v-if="tenants && tenants.length > 0" class="my-5">
        <div class="fs-2 py-5 text-uppercase fw-bolder text-primary">
          Séléctionnez un tenant
        </div>

        <div class="d-flex gap-5 flex-wrap">
          <label v-for="tenant in tenants"
                 :class="{ 'bg-light-primary': selected?.code === tenant.code }"
                 class="flex-fill d-flex align-items-center border-primary border rounded border-dashed p-5 fw-bolder text-primary min-w-150px cursor-pointer">
            <span class="form-check form-check-sm form-check-custom me-2">
              <input :key="'tenant_input_'+tenant.code" v-model="selected" :value="tenant" class="form-check-input widget-9-check" name="tenant" type="radio"/>
            </span>
            <span class="text-truncate"> {{ tenant.label }}</span>
          </label>
        </div>
      </div>
      <div v-else>
        <div class="mw-400px py-5 text-uppercase">
          <div class="text-danger fw-bolder fs-2 bg-light-danger rounded py-2 my-5 ">
           Aucun accès disponible
          </div>
          <div class="mt-5">
            Contactez l'un de nos agents afin de vous en accorder
          </div>
        </div>
      </div>
      <div class="py-5 d-flex justify-content-between gap-5">
        <div class="btn btn-secondary btn-lg flex-1 d-flex justify-content-start gap-2 align-items-center" @click="logout">
          <i class="fad fa-power-off fs-2"></i>
          Connexion
        </div>
        <div class="btn btn-primary btn-lg d-flex align-items-center flex-1 justify-content-end gap-2" @click="setTenant">
          Suivant
          <i class="fad fa-angle-right fs-2"></i>
        </div>

      </div>
    </div>
  </div>
</template>


<script lang="ts">
import {Component, Vue} from 'vue-property-decorator';
import store from "@/store";
import {auth} from "@/services/Auth";
import Logo from "@/components/Logo.vue";
import impersonateService from "@/services/impersonateService";

@Component({
  components: {Logo}
})
export default class TenantSelector extends Vue {
  currentTenant = null
  selected = null

  get tenants() {
    return auth.getTenants()
  }

  get user() {
    return auth.getCurrentUser()
  }

  get username() {
    if (this.user) {
      return this.user.name + ' ' + this.user.prename

    }
    return ''
  }

  mounted() {
    this.currentTenant = store.state.mainStore.currentTenant
    console.log(this.currentTenant)
  }

  setTenant() {
    if (this.selected?.code) {
      localStorage.setItem('currentTenant', JSON.stringify(this.selected))
      store.state.mainStore.currentTenant = this.selected
      this.$router.push({name: 'home'})
    }
  }

  async logout() {
    const isImpersonated = await impersonateService.hasBackup()
    if (isImpersonated) {
      await impersonateService.restoreLocalStorage()
      window.location.reload()
    } else {
      auth.logout();
    }
  }

}
</script>
<style scoped>

</style>
